<script setup lang="ts"></script>

<template>
  <div class="l-auth">
    <router-view />
  </div>
</template>

<style scoped lang="scss"></style>
